import { render, staticRenderFns } from "./TableColumnSetting.vue?vue&type=template&id=3a9068fa&scoped=true&"
import script from "./TableColumnSetting.vue?vue&type=script&lang=js&"
export * from "./TableColumnSetting.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnSetting.vue?vue&type=style&index=0&id=3a9068fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9068fa",
  null
  
)

export default component.exports